import Immutable from 'seamless-immutable';
import createReducer from '../helpers/createReducer';
import state from '../store/plugin';

export default createReducer(state, {
  SET_UUID: (state, { data }) => Immutable({ ...state, uuid: data }),
  SET_PLUGINID: (state, { data }) => Immutable({ ...state, pluginId: data }),
  SET_PROJECTID: (state, { data }) => Immutable({ ...state, projectId: data }),
  SET_STORE_DISTRICTS: (state, { data }) => Immutable({ ...state, storeDistricts: data }),
  SET_ENCODE_PLUGINID: (state, { data }) => Immutable({ ...state, enCodePluginId: data }),
  SET_IS_LOADING: (state, { data }) => Immutable({ ...state, isLoading: data }),
  SET_X_GW: (state, { data }) => Immutable({ ...state, xgw: data }),
});
